const UserProfile = () =>import(/* webpackChunkName 'UserProfile' */ '@/components/SalesReport/SalesReportList.vue');

export default {
    path: 'sales',
    name: 'sales',
    meta: {
        label: 'Sales Report'
    },
    props: true,
    component: UserProfile
};